var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcActionLocationOff(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M13 2h-2v2.062A7.96 7.96 0 0 0 7.094 5.68L3.707 2.293 2.293 3.707l18 18 1.414-1.414-3.387-3.387A7.96 7.96 0 0 0 19.938 13H22v-2h-2.062A8.004 8.004 0 0 0 13 4.062V2Zm3.89 13.476A5.966 5.966 0 0 0 18 12a6.005 6.005 0 0 0-7-5.917 5.968 5.968 0 0 0-2.477 1.026l8.368 8.367Z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.062 11a7.946 7.946 0 0 1 .608-2.21l.123.124 1.455 1.375A5.958 5.958 0 0 0 6 12a6.005 6.005 0 0 0 7.56 5.795l1.596 1.558c-.676.29-1.4.49-2.156.585V22h-2v-2.062A8.004 8.004 0 0 1 4.062 13H2v-2h2.062Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcActionLocationOff);
export default __webpack_public_path__ + "static/media/ic_action_location_off.7c11e450875526d4212fde804ed2a282.svg";
export { ForwardRef as ReactComponent };